import React, { useState } from "react";
import NavbarSuperAdmin from "../../../components/navbar/NavbarSuperAdmin";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import TableBody from "@material-ui/core/TableBody";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";
import { connect } from "react-redux";
import { API_BASE_PATH } from "../../../constants/workerConstants";
import { Paper } from "@material-ui/core";
import ContentDialog from "../../../components/ui/app-modal/ContentDialog";
import dateFormat from "dateformat";
import Spinner from "../Spinner";

function MedicineManagement(props) {
  const [dataDays, setDataDays] = useState([]);
  const [changeDate, setChangeDate] = useState(new Date().toDateString());
  const [openTask, setOpenTask] = useState(false);
  const [findTask, setFindTask] = useState();
  const [loading, setLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    date: "",
    reminder: "",
    time: "",
  });
  React.useEffect(() => {
    getDateData();
  }, [changeDate]);

  const getDateData = async () => {
    setLoading(true);
    axios
      .post(
        `${API_BASE_PATH}/todo/CalendardataForMonth`,
        {
          reqDate: "" + new Date(changeDate),
          event: "medication",
        },
        {
          headers: {
            authorization: props.authToken,
          },
        }
      )
      .then((resp) => {
        if (resp.status === 200) {
          setDataDays(resp.data.result.days);
          console.log("setDataDays", resp.data.result.days);
          setLoading(false);
          if (resp.data.result.data !== null) {
            setFindTask(resp.data.result.data);
          }
        }
      });
  };

  const values = dataDays.map((item) => {
    var d = new Date(item.date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    var date = [year, month, day].join("-");
    var title = item.title;
    var time = item.time;
    return { title, date, time };
  });
  const particularDate = async (date) => {
    console.log("particularDate", date);
    axios
      .post(
        `${API_BASE_PATH}/todo/CalendardataForMonth`,
        {
          reqDate: "" + date,
          event: "medication",
        },
        {
          headers: {
            authorization: props.authToken,
          },
        }
      )
      .then((resp) => {
        if (resp.status === 200) {
          setFindTask(resp.data.result.data);
          if (resp.data.result.data !== null) {
            setFindTask(resp.data.result.data);
          }
        }
      });
  };

  const handleDateClick = (dateClickInfo) => {
    console.log(dateClickInfo.dateStr);
    console.log(dateClickInfo.date);
    setOpenTask(true);
    particularDate(dateClickInfo.date);
  };

  const getDates = (dateInfo) => {
    var chengenewDate = new Date().toUTCString();
    var checkDate = new Date(
      dateInfo.view.getCurrentData().currentDate
    ).toUTCString();

    if (chengenewDate.substring(0, 16) !== checkDate.substring(0, 16)) {
      console.log(
        new Date(chengenewDate).getDate(),
        new Date(checkDate).getDate(),
        checkDate
      );
      setChangeDate(new Date(dateInfo.view.getCurrentData().currentDate));
    }
  };

  return (
    <div>
      <NavbarSuperAdmin />

      <div style={{ position: "relative" }}>
        <Table
          style={{
            marginTop: "15px",
            marginBottom: "100px",
            marginLeft: "82px",
            width: "77%",
          }}
        >
          <TableHead>
            <div class="header" style={{ marginTop: "0px" }}>
              <KeyboardBackspaceIcon
                onClick={() => window.history.back()}
                style={{
                  marginTop: "70px",
                  marginLeft: "-7px",
                  height: "40px",
                  width: "40px",
                }}
              />
              <h4
                style={{
                  position: "relative",
                  marginTop: "-34px",
                  marginLeft: "40px",
                  width: "100%",
                }}
              >
                <b>Medicine Management</b>
              </h4>
              <div
                style={{
                  height: "60px",
                  position: "relative",
                  cursor: "pointer",
                }}
              >
                <FullCalendar
                  height="auto"
                  width="auto"
                  plugins={[dayGridPlugin, interactionPlugin]}
                  events={values}
                  dateClick={handleDateClick}
                  eventBorderColor="#f9e6d6"
                  initialView="dayGridMonth"
                  eventBackgroundColor="#f9e6d6"
                  datesSet={getDates}
                  eventTextColor="black"
                />
              </div>
              {loading && <Spinner />}
              <div
                style={{
                  display: "flex",
                  marginLeft: "65%",
                  marginTop: "-62px",
                }}
                open={openTask}
              >
                <div
                  className="top"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "83%",
                  }}
                >
                  <Paper
                    type="button"
                    class="btn btn-primary"
                    style={{
                      marginLeft: "101%",
                      alignItems: "right",
                      width: "295%",
                      maxHeight: "13%",
                      paddingLeft: "2px",
                      backgroundColor: "rgb(29, 117, 189)",
                    }}
                  >
                    Medicine
                    {/* <button
                      type="button"
                      class="btn btn-primary"
                      style={{
                        alignItems: "right",
                        paddingLeft: "100px",
                        backgroundColor: "rgb(29, 117, 189)",
                        border: "none",
                      }}
                    >
                      +
                    </button> */}
                  </Paper>
                </div>
                <div className="down" style={{ marginTop: "57px" }}>
                  <Paper
                    variant="h4"
                    elevation={3}
                    style={{
                      minHeight: "460px",
                      textAlign: "center",
                      width: "240px",
                    }}
                  >
                    {findTask !== undefined && findTask.length === 0
                      ? "There is no data in Medicine"
                      : " "}

                    {findTask !== undefined &&
                      findTask.length > 0 &&
                      findTask.map((value) => {
                        return (
                          <div>
                            <div
                              style={{
                                color: "rgb(29, 117, 189)",

                                paddingTop: "10px",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  textAlign: "left",
                                  paddingLeft: "3px",
                                }}
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: value.days.splits.map(
                                      (item) => item.content
                                    ),
                                    time: value.days.splits.map(
                                      (item) => item.time
                                    ),
                                    date: dateFormat(value.days.date, "mm/dd/yyyy"),
                                    reminder: value.reminder,
                                  });
                                }}
                              >
                                {value.days.splits.map((item) => (
                                  <div>
                                    {item.content.length < 30
                                      ? item.content
                                      : ""}
                                    {item.content.length > 65
                                      ? item.content.slice(0, 65) + "..."
                                      : " "}
                                  </div>
                                ))}
                              </div>
                              <div
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "3px",
                                }}
                              >
                                {dateFormat(value.days.date, "mm/dd/yyyy")}
                                {value.days.splits.map((item) => (
                                  <div>{item.time}</div>
                                ))}
                                <div>{value.reminder}</div>
                              </div>
                            </div>
                            {/* <Delete
                              style={{
                                cursor: "pointer",
                                color: "red",
                                marginTop: "-62px",
                                marginLeft: "176px",
                              }}
                            /> */}
                            <hr />
                          </div>
                        );
                      })}
                  </Paper>
                </div>
              </div>
            </div>
          </TableHead>
          <TableBody></TableBody>
        </Table>
      </div>
      <ContentDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}
const mapStateToProps = (state) => {
  console.log(state);
  return {
    authToken: state.persist.authToken,
    userData: state.persist.userData,
  };
};

export default connect(mapStateToProps)(MedicineManagement);
